import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Table } from "react-bootstrap";
import edititem from "../../../components/Images/edititem.svg";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import "./EmailSettings.css";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import { RiLockPasswordLine } from "react-icons/ri";
import { TbEyeClosed } from "react-icons/tb";
import { VscEye } from "react-icons/vsc";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight, MdOutlineMailOutline } from "react-icons/md";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { toast } from "react-toastify";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import { ActionFormatterTemplateComponent } from "../../../components/CommonMethod/CommonBoostrapFormatter";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
function EmailSettings(props) {

  const { fetchRequest, globalImageUplaodAPI } = useMyContext();
  const access_token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const imageApi = globalImageUplaodAPI()



  const adminEmailRef = useRef(null)
  const userEmailRef = useRef(null)
  const passWordRef = useRef(null)
  const emailHostRef = useRef(null)
  const emailPortRef = useRef(null)
  const emailSenderTypeRef = useRef(null)
  const secureRef = useRef(null)
  const postmarkfromaddressRef = useRef(null)
  const postmarkapitokenRef = useRef(null)
  const userTestEmailRef = useRef(null)
  const newsletterSubjectRef = useRef(null)
  const newsletterTemplateRef = useRef(null)
  const combinedRef = useRef({});
  const [searchValue, setSearchValue] = useState('');
  const [passwordType, setPasswordType] = useState("password");
  const [template, setTemplate] = useState([]);
  const [originalTemplate, setOriginalTemplate] = useState([]); // Add this line
  const [newsletterTemplates, setNewsletterTemplates] = useState([]);
  const [originalNewsletterTemplates, setOriginalNewsletterTemplates] = useState([]);
  const [activeTableView, setActiveTableView] = useState('email'); // 'email' or 'newsletter'
  const [showOverlay, setShowOverlay] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [edituserforget, setEditUserforget] = useState({
    forget_password_limit: "",
    forget_password_exists_after_minutes: "",

  });

  const [editUser, setEditUser] = useState({
    email_sender_type: "",
    postmark_from_address: "",
    postmark_API_token: "",
    admin_email: "",
    user_email: "",
    email_password: "",
    host_email: "",
    email_port: "",
    secure: "",
    enable_email_logo: 1,
    enable_newsletter: 0,
    newsletter_subject: "",
    newsletter_template: "",
    status: 0
  });

  const [editUserError, setEditUserError] = useState({})
  const [coverImageFile, setCoverImageFile] = useState(null);
  const [defaultOption, setDefaultOption] = useState("");

  const [editUsertest, setEditUsertest] = useState({
    test_mail: "",
  });

  const [productType, setProductType] = useState('full_package');
  const productTypeFromEnv = process.env.REACT_APP_DEPLOYMENT_PRODUCT_TYPE;


  useEffect(() => {
    let isMounted = true;
    const run = async () => {
      try {
        if (productTypeFromEnv && productTypeFromEnv.trim() !== "") {
          if (isMounted) setProductType(productTypeFromEnv);
        } else {
          const resp = await axios.get(
            `${process.env.REACT_APP_Baseurl}/admin/main-settings/get`,
            { headers, params: { fields: 'productType' } }
          );
          if (isMounted) setProductType(resp?.data?.data?.productType || 'full_package');
        }
      } catch (e) {
        if (isMounted) setProductType('full_package');
      }
    };
    run();
    return () => { isMounted = false; };
  }, []);

  const regexNumber = /^[0-9]+$/;
  const regexTime = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/;

  const handleFilterChange = (value) => {
    setSearchValue(value);
    if (value) {
      const filtered = originalTemplate.filter(item =>
        item.template_type?.toLowerCase().includes(value.toLowerCase()) ||
        item.heading?.toLowerCase().includes(value.toLowerCase())
      );
      setTemplate(filtered);
    } else {
      setTemplate(originalTemplate);
    }
  };

  const getEmail = async () => {
    setShowOverlay(true)
    await fetchRequest({
      method: 'GET',
      url: `${process.env.REACT_APP_Baseurl}/admin/email-index`,
      params: {},
      data: {},
    })
      .then(response => {
        setDefaultOption(response?.email_sender_type.filter(item => item.value != null));
        setEditUser(response?.email_settings);
        setEditUsertest(response?.email_settings);
        setEditUserforget(response?.email_settings);
        setShowOverlay(false)
      })
      .catch(error => {
        setShowOverlay(false)
      })
  }

  const getTemplate = async () => {
    setShowOverlay(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/email-template/index`, { headers });
      const result = response?.data?.email_template;
      setTemplate(result);
      setOriginalTemplate(result);
    } catch (error) {
      console.error("Error fetching email templates:", error);
    } finally {
      setShowOverlay(false);
    }
  };

  const getNewsletterTemplates = async () => {
    setShowOverlay(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/newsletter-template/index`, { headers });
      const result = response?.data?.newsletter_template || [];
      setNewsletterTemplates(result);
      setOriginalNewsletterTemplates(result);
    } catch (error) {
      console.error("Error fetching newsletter templates:", error);
      // If endpoint doesn't exist, set empty arrays
      setNewsletterTemplates([]);
      setOriginalNewsletterTemplates([]);
    } finally {
      setShowOverlay(false);
    }
  };
  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;
    let updatedValue;
    if (type === "checkbox") {
      if (name === "status") {
        updatedValue = checked ? 1 : 0;
      } else {
        updatedValue = checked;
      }
      setEditUser((prev) => ({
        ...prev,
        [name]: updatedValue,
      }));
    } else if (name === "email_password") {
      const filteredValue = value.replace(/[ #]/g, "");
      setEditUser((prev) => ({
        ...prev,
        [name]: filteredValue,
      }));
      setEditUsertest((prev) => ({
        ...prev,
        [name]: filteredValue,
      }));
    } else if (type === "text" || type === "number" || type === "select-one" || type === "email") {
      setEditUser((prev) => ({
        ...prev,
        [name]: value,
      }));
      setEditUsertest((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    setEditUserError((prev) => ({
      ...prev,
      [name]: null,
    }));
  };

  const handleValidate = async (e) => {
    if (formValidation()) {
      handleUpdate()
    }
    else {
      console.log("Form validation failed ");
    }
  }

  const handleTestEmailValid = async () => {
    if (formTestEmailValidation()) {
      handleEmailSend()
    }
    else {
      console.log("Form validation failed ");
    }
  }

  const handleUpdate = async () => {

    const editUserUpdate = {
      "email_sender_type": editUser?.email_sender_type,
      "postmark_from_address": editUser?.postmark_from_address,
      "postmark_API_token": editUser?.postmark_API_token,
      "admin_email": editUser?.admin_email,
      "host_email": editUser?.host_email,
      "email_port": editUser?.email_port,
      "secure": editUser?.secure,
      "email_user": editUser?.user_email,
      "password": editUser?.email_password,
      "enable_email_logo": editUser?.enable_email_logo,
      "enable_newsletter": editUser?.enable_newsletter,
      "newsletter_subject": editUser?.newsletter_subject,
      "newsletter_template": editUser?.newsletter_template,
      "status": editUser?.status
    }
    setShowOverlay(true)
    try {
      const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/email-update`, editUserUpdate, { headers: headers })
      if (response?.data?.status) {
        setShowOverlay(false)
        await handleFileUpload()
        getEmail()
        toast.success(response.data?.message)
      }
    }

    catch (error) {
      console.error("Error:", error);
    }
  }

  const handleEmailSend = async () => {
    setShowOverlay(true)
    const editUserUpdate = {
      "email": editUser?.test_mail,
    }
    await axios.post(`${process.env.REACT_APP_Baseurl}/admin/email-verify`, editUserUpdate, { headers: headers }).then((res) => {
      setShowOverlay(false)
      toast.success(res.data?.message)
    }).catch((error) => {
      const errMessage = error?.response?.data?.message || "Failed to send email"
      setShowOverlay(false)
      toast.error(errMessage)
      console.error("Error:", errMessage);
    })
  }


  const handleFileUpload = async () => {
    try {
      const formDataAdd = new FormData();
      const imageFields = [];
      formDataAdd.append('id', editUser?.id)
      formDataAdd.append('modelName', 'EmailSetting');
      formDataAdd.append('email_logo', coverImageFile)
      imageFields.push("email_logo");
      imageFields.forEach((field) => {
        formDataAdd.append('imageFields[]', field);
      });
      try {
        const response = await fetchRequest({
          method: 'POST',
          url: imageApi,
          data: formDataAdd,
        });
      }
      catch (error) {
        console.error("Error While email logo update", error)
      }
      setCoverImageFile(null)
    } catch (err) {
      toast.error(err?.response?.data?.message)
    }
  }


  const formValidation = () => {
    let formIsValid = true;
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!editUser?.admin_email) {
      setEditUserError((prevFormData) => ({
        ...prevFormData,
        admin_email: "Email cannot be empty.",
      }));
      adminEmailRef.current.focus();
      formIsValid = false;
    }
    if (!regex.test(editUser?.admin_email)) {
      setEditUserError((prevFormData) => ({
        ...prevFormData,
        admin_email: "Email format is incorrect.",
      }));
      adminEmailRef.current.focus();
      formIsValid = false;
    }
    if (!edituserforget?.forget_password_limit) {
      setEditUserError((prev) => ({
        ...prev,
        forget_password_limit: "Password limit cannot be empty.",
      }));
      formIsValid = false;
    }
    if (!regexNumber.test(edituserforget?.forget_password_limit)) {
      setEditUserError((prev) => ({
        ...prev,
        forget_password_limit: "Password limit must be a number.",
      }));
      formIsValid = false;
    }

    if (!edituserforget?.forget_password_exists_after_minutes) {
      setEditUserError((prev) => ({
        ...prev,
        forget_password_exists_after_minutes: "Time cannot be empty.",
      }));
      formIsValid = false;
    }
    if (!regexTime.test(edituserforget?.forget_password_exists_after_minutes)) {
      setEditUserError((prev) => ({
        ...prev,
        forget_password_exists_after_minutes: "Time format must be HH:MM.",
      }));
      formIsValid = false;
    }


    if (editUser?.email_sender_type == "smtp") {
      if (!editUser?.user_email) {
        setEditUserError((prevFormData) => ({
          ...prevFormData,
          user_email: "Email cannot be empty.",
        }));
        userEmailRef.current.focus();
        formIsValid = false;
      }
      if (!regex.test(editUser?.user_email)) {
        setEditUserError((prevFormData) => ({
          ...prevFormData,
          user_email: "Email format is incorrect.",
        }));
        userEmailRef.current.focus();
        formIsValid = false;
      }
      if (!editUser?.email_password) {
        setEditUserError((prevFormData) => ({
          ...prevFormData,
          email_password: "Passsword cannot be empty",
        }));
        passWordRef.current.focus();
        formIsValid = false;
      }
      if (!editUser?.email_port) {
        setEditUserError((prevFormData) => ({
          ...prevFormData,
          email_port: "Email port cannot be empty",
        }));
        emailPortRef.current.focus();
        formIsValid = false;
      }
      if (!editUser?.host_email) {
        setEditUserError((prevFormData) => ({
          ...prevFormData,
          host_email: "Email host cannot be empty",
        }));
        emailHostRef.current.focus();
        formIsValid = false;
      }
      if (!editUser?.secure || editUser?.secure === "null") {
        setEditUserError((prevFormData) => ({
          ...prevFormData,
          secure: "Secure cannot be empty",
        }));
        secureRef.current.focus();
        formIsValid = false;
      }
    }

    if (editUser?.email_sender_type == "postmark") {
      if (!editUser?.postmark_from_address) {
        setEditUserError((prevFormData) => ({
          ...prevFormData,
          postmark_from_address: "Postmark from address cannot be empty",
        }));
        postmarkfromaddressRef.current.focus();
        formIsValid = false;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editUser.postmark_from_address)) {
        setEditUserError((prevFormData) => ({
          ...prevFormData,
          postmark_from_address: "Email format is incorrect."
        }));
        postmarkfromaddressRef.current.focus();
        formIsValid = false;
      }
      if (!editUser?.postmark_API_token) {
        setEditUserError((prevFormData) => ({
          ...prevFormData,
          postmark_API_token: "Postmark API token cannot be empty",
        }));
        postmarkapitokenRef.current.focus();
        formIsValid = false;
      }
    }

    // Newsletter validation
    if (editUser?.enable_newsletter == 1) {
      if (!editUser?.newsletter_subject) {
        setEditUserError((prevFormData) => ({
          ...prevFormData,
          newsletter_subject: "Newsletter subject cannot be empty.",
        }));
        newsletterSubjectRef.current.focus();
        formIsValid = false;
      }
      if (!editUser?.newsletter_template) {
        setEditUserError((prevFormData) => ({
          ...prevFormData,
          newsletter_template: "Newsletter template cannot be empty.",
        }));
        newsletterTemplateRef.current.focus();
        formIsValid = false;
      }
    }

    // if (!coverImageFile) {
    //   setEditUserError((prevFormData) => ({
    //     ...prevFormData,
    //     email_logo: "Email logo cannot be empty",
    //   }));
    //   combinedRef.current['email_logo'].focus();
    //   formIsValid = false;
    // }
    return formIsValid
  }

  const formTestEmailValidation = () => {
    let formIsValid = true;
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!editUser?.test_mail) {
      setEditUserError((prevFormData) => ({
        ...prevFormData,
        test_mail: "Email cannot be empty.",
      }));
      userTestEmailRef.current.focus();
      formIsValid = false;
    } else if (!regex.test(editUser?.test_mail)) {
      setEditUserError((prevFormData) => ({
        ...prevFormData,
        test_mail: "Email format is incorrect.",
      }));
      userTestEmailRef.current.focus();
      formIsValid = false;
    }
    return formIsValid
  }

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const options = {
    totalSize: template.length,
    page: currentPage,
    onPageChange: (page) => setCurrentPage(page),
    onSizePerPageChange: (sizePerPage, page) => {
      setPageSize(sizePerPage);
      setCurrentPage(page);
    },
    pageStartIndex: 1,
    paginationSize: 3,
    sizePerPage: pageSize,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [
      { text: '5', value: 5 },
      { text: '10', value: 10 },
      { text: 'All', value: template?.length || 0 }
    ]
  };

  const confirmToggle = async (row) => {
    setShowOverlay(true);
    try {
      const newStatus = row.status === 1 ? 0 : 1;

      const response = await axios.patch(
        `${process.env.REACT_APP_Baseurl}/admin/email-template-status/update/${row.id}`,
        { status: newStatus },
        { headers }
      );

      const result = response.data;
      if (result.status) {
        setShowOverlay(false)
        getEmail()
        getTemplate()
        toast.success(result?.message);
      } else {
        toast.error(result?.message);
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message;
      toast.error(errorMessage || 'Something went wrong');
    } finally {
      setShowOverlay(false);
    }
  };

  const confirmNewsletterToggle = async (row) => {
    setShowOverlay(true);
    try {
      const newStatus = row.status === 1 ? 0 : 1;

      const response = await axios.patch(
        `${process.env.REACT_APP_Baseurl}/admin/newsletter-template-status/update/${row.id}`,
        { status: newStatus },
        { headers }
      );

      const result = response.data;
      if (result.status) {
        setShowOverlay(false)
        getNewsletterTemplates()
        toast.success(result?.message);
      } else {
        toast.error(result?.message);
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message;
      toast.error(errorMessage || 'Something went wrong');
    } finally {
      setShowOverlay(false);
    }
  };

  const columns = [
    {
      dataField: "index",
      text: "S.No",
      // sort: false,
      headerClasses: "serialNumber",
      formatter: (cell, row, rowIndex) => {
        return (currentPage - 1) * pageSize + rowIndex + 1;  // Calculate the serial number
      },
    },
    {
      dataField: "template_type",
      text: "TEMPLATE",
      // sort: true,
    },
    {
      dataField: "heading",
      text: "SUBJECT",
      // sort: true,
    },
    {
      dataField: "status",
      text: "STATUS",
      formatter: (cell, row) => (
        <AdminSwitch name={'status'} id="status" checked={Number(cell) === 1} onChange={() => confirmToggle(row)} />
      )
    },
    {
      dataField: "ACTION",
      text: "ACTION",
      headerClasses: "serialNumber",
      formatter: (cell, row) => <ActionFormatterTemplateComponent cell={cell} row={row} link={'/edit-template-email/'} />,
    },
  ];

  const newsletterColumns = [
    {
      dataField: "index",
      text: "S.No",
      headerClasses: "serialNumber",
      formatter: (cell, row, rowIndex) => {
        return (currentPage - 1) * pageSize + rowIndex + 1;
      },
    },
    {
      dataField: "template_name",
      text: "TEMPLATE NAME",
    },
    {
      dataField: "subject",
      text: "SUBJECT",
    },
    {
      dataField: "status",
      text: "STATUS",
      formatter: (cell, row) => (
        <AdminSwitch name={'status'} id="status" checked={Number(cell) === 1} onChange={() => confirmNewsletterToggle(row)} />
      )
    },
    {
      dataField: "ACTION",
      text: "ACTION",
      headerClasses: "serialNumber",
      formatter: (cell, row) => <ActionFormatterTemplateComponent cell={cell} row={row} link={'/edit-newsletter-template/'} />,
    },
  ];

  const handleFileChange = async (event) => {
    const { files, name, value, accept } = event.target
    if (files?.length > 0) {
      const newFile = files[0];
      const reader = new FileReader();
      const readFile = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });
      };
      const fileContent = await readFile(newFile);

      if (name == 'image') {
        setCoverImageFile(newFile);
        setEditUserError((prev) => ({
          ...prev,
          ['email_logo']: ""
        }))
      }
    }
  };
  const handleClearSelectFile = (value) => {
    if (value == 'image') {
      setCoverImageFile(null)
    }
  }

  useEffect(async () => {
    getEmail();
    getTemplate()
    getNewsletterTemplates()
  }, []);

  // const handleInputdatatime = (e) => {
  //   const inputName = e.target.name;
  //   const inputValue = e.target.value;

  //   // Remove non-digit characters from input
  //   const formattedInput = inputValue.replace(/\D/g, "");

  //   // Add colons to maintain the format HH:MM:SS
  //   const formattedTime = formattedInput
  //     .replace(/^(\d{2})(\d{2})(\d{2})$/, "$1:$2:$3")
  //     .substr(0, 8);

  //   setEditUserforget({
  //     ...edituserforget,
  //     [inputName]: formattedTime,
  //   });
  // };
  const handleInputforget = (e) => {
    const { name, value } = e.target;
    setEditUserforget((prev) => ({
      ...prev,
      [name]: value,
    }));
    setEditUserError((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleInputdatatime = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value.replace(/\D/g, "");

    let formattedTime = "";
    if (inputValue.length <= 2) {
      formattedTime = inputValue;
    } else {
      formattedTime = inputValue.slice(0, 2) + ":" + inputValue.slice(2, 4);
    }

    setEditUserforget((prev) => ({
      ...prev,
      [inputName]: formattedTime,
    }));

    setEditUserError((prev) => ({
      ...prev,
      [inputName]: "",
    }));
  };

  const handleSubmit = async () => {
    const timeRegex = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/; // Validates HH:MM (24h)
    const numberRegex = /^[0-9]+$/;

    const { forget_password_limit, forget_password_exists_after_minutes } = edituserforget;

    // Client-side validation
    if (!forget_password_limit || !numberRegex.test(forget_password_limit)) {
      toast.error("Please enter a valid number for the password limit");
      return;
    }

    if (!forget_password_exists_after_minutes || !timeRegex.test(forget_password_exists_after_minutes)) {
      toast.error("Please enter time in HH:MM format");
      return;
    }

    setShowOverlay(true);

    try {
      const payload = {
        forget_password_limit,
        forget_password_exists_after_minutes,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/email-limit-restriction`,
        payload,
        { headers: headers }
      );

      if (response.data.status) {
        toast.success(response.data.message || "Limit Restriction updated successfully!");

        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        toast.error(response.data.message || "Something went wrong");
      }
    } catch (error) {
      console.error("POST request failed:", error);
      toast.error("Something went wrong while submitting.");
    } finally {
      setShowOverlay(false);
    }
  };



  return (
    <div className="">
      {showOverlay && <Response_Processing></Response_Processing>}
      <AdminSaveHeader heading="Email Setting" saveText=" Update Settings" saveMethod={handleValidate} />

      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text='E-mail Sender Type' />
            <MessageLabel text="Select e-mail sender type" className="mandatorySimple" />
            <AdminCustomSelect
              name="email_sender_type"
              value={editUser?.email_sender_type || ""}
              onChange={handleInput}
              ref={emailSenderTypeRef}
              options={defaultOption?.length ? defaultOption.map((item, index) => ({
                name: item?.name,
                value: item?.value,
                key: item?.value || index
              })) : []}
              error={editUserError?.email_sender_type}
            />
          </Wrapper>
          {editUser?.email_sender_type == "smtp" ?
            <Wrapper>
              <MessageHeading text='SMTP Configuration' />
              <MessageLabel text="Email Host" className="mandatorySimple" />
              <AdminCustomInput type="text" id="host_email" placeHolder={"Enter host"} name="host_email" ref={emailHostRef} value={editUser?.host_email} onChange={handleInput} error={editUserError?.host_email} />
              <MessageLabel text="Email Port" className="mandatorySimple" />
              <AdminCustomInput type="number" min={0} id="email_port" placeHolder={"Enter email port number"} name="email_port" ref={emailPortRef} value={editUser?.email_port} onChange={handleInput} error={editUserError?.email_port} />
              <MessageLabel text="Secure" />
              <AdminCustomSelect
                name="secure"
                value={editUser?.secure || ""}
                onChange={handleInput}
                ref={secureRef}
                options={[
                  { name: "Select the Secure", value: "null", key: "null" },
                  { name: "TRUE", value: "true", key: "true" },
                  { name: "FALSE", value: "false", key: "false" }
                ]}
                error={editUserError?.secure}
              />
              <MessageLabel text="Email User" className="mandatorySimple" />
              <AdminCustomInput type="email" id="user_email" placeHolder={"Enter user email"} name="user_email" ref={userEmailRef} value={editUser?.user_email} onChange={handleInput} error={editUserError?.user_email} />
              <MessageLabel text="Email Password" className="mandatorySimple" />
              <div className="position-relative">
                <input type={passwordType} name="email_password" value={editUser?.email_password} onChange={handleInput} placeholder="Enter Password" ref={passWordRef} className="rs-input py-3 px-5 form-control-lg custom-placeholder theme-text-color  mb-3" autoComplete="off" />
                <button onClick={togglePassword} className="position-absolute passWordIcon bg-transparent">
                  {passwordType == "password" ? <TbEyeClosed className="eyeClosed " /> : <VscEye className="eyeOpen " />}
                </button>
                <RiLockPasswordLine className="lockIcon position-absolute" />
                {editUserError?.email_password && (<MessageBox text={`${editUserError?.email_password}`} classname='errorred mb-2 d-block' />)}
              </div>
            </Wrapper>
            : ""}
          {editUser?.email_sender_type == "postmark" ?
            <Wrapper>
              <MessageHeading text='POSTMARK Configuration' />
              <MessageLabel text="E-mail Postmark" className="mandatorySimple" />
              <AdminCustomInput type="email" id="postmark_from_address" placeHolder={"Enter postmark from address"} name="postmark_from_address" ref={postmarkfromaddressRef} value={editUser?.postmark_from_address} onChange={handleInput} error={editUserError?.postmark_from_address} />
              <MessageLabel text="Postmark API token" className="mandatorySimple" />
              <AdminCustomInput type="text" id="postmark_API_token" placeHolder={"Enter postmark api token"} name="postmark_API_token" ref={postmarkapitokenRef} value={editUser?.postmark_API_token} onChange={handleInput} error={editUserError?.postmark_API_token} />
            </Wrapper>
            : ""}
          <Wrapper>
            <MessageHeading text='Forget Password Limit' />
            <MessageLabel text="Password Limit" className="" />
            <AdminCustomInput type="number" min={0} id="forget_password_limit" placeHolder={"Enter password limit"} name="forget_password_limit" value={edituserforget?.forget_password_limit} onChange={handleInputforget} error={editUserError?.forget_password_limit} />
            <MessageLabel text="Password Exists After Minutes" className="" />
            <AdminCustomInput type="text" id="forget_password_exists_after_minutes" placeHolder={"HH:MM"} name="forget_password_exists_after_minutes" value={edituserforget?.forget_password_exists_after_minutes} onChange={handleInputdatatime} error={editUserError?.forget_password_exists_after_minutes} />
            <AdminCustomButton saveMethod={handleSubmit} saveText={"Save"} className={"d-flex justify-content-end ms-auto"} />
            {/* <button type="button" onClick={handleSubmit} className="button-bg-color  theme-button-text-color admin-button-text mt-2 rounded-3  py-2 px-3">Submit</button> */}
          </Wrapper>
        </LeftWrapper>

        <RightWrapper>
          <Wrapper>
            <MessageHeading text='Create Email' />
            <MessageLabel text="Admin Email" className="mandatorySimple" />
            <AdminCustomInput type="email" id="admin_email" placeHolder={"Enter admin email"} name="admin_email" ref={adminEmailRef} value={editUser?.admin_email} onChange={handleInput} error={editUserError?.admin_email} />
            <MessageLabel text={"Email logo"} />
            <AdminImageUploadZone
              onChange={handleFileChange}
              selectedFile={coverImageFile}
              uploadedImage={editUser?.email_logo}
              onDelete={handleClearSelectFile}
              ref={(el) => (combinedRef.current.email_logo = el)}
              name="image"
              id
              error={editUserError?.email_logo}
              className="mail_logos w-100 h-100 AdminImageUploader"

            />
            <div className="d-flex justify-content-between mb-2 ">
              <div className="cFVol-6 col-md-6 pe-2">
                <MessageLabel text={"Enable logo"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'enable_email_logo'} checked={editUser?.enable_email_logo == 1} onChange={handleInput} />
              </div>
            </div>
          </Wrapper>
          <Wrapper>
            <MessageHeading text={"Email Status"} />
            <div className="d-flex justify-content-between flex-wrap mb-2">
              <div className="col-6 col-md-10 pe-2">
                <MessageLabel text={"Status"} />
              </div>
              <div className="col-6 col-md-2 ps-2 text-end">
                <AdminSwitch name={'status'} checked={editUser?.status == 1} onChange={handleInput} />
              </div>
            </div>
          </Wrapper>
          <Wrapper>
            <MessageHeading text='Newsletter Settings' />
            <div className="d-flex justify-content-between flex-wrap mb-2">
              <div className="col-6 col-md-10 pe-2">
                <MessageLabel text={"Enable Newsletter"} />
              </div>
              <div className="col-6 col-md-2 ps-2 text-end">
                <AdminSwitch name={'enable_newsletter'} checked={editUser?.enable_newsletter == 1} onChange={handleInput} />
              </div>
            </div>
            {editUser?.enable_newsletter == 1 && (
              <>
                <MessageLabel text="Newsletter Subject" className="mandatorySimple" />
                <AdminCustomInput
                  type="text"
                  id="newsletter_subject"
                  placeHolder={"Enter newsletter subject"}
                  name="newsletter_subject"
                  ref={newsletterSubjectRef}
                  value={editUser?.newsletter_subject}
                  onChange={handleInput}
                  error={editUserError?.newsletter_subject}
                />
                <MessageLabel text="Newsletter Template" className="mandatorySimple" />
                <textarea
                  className="rs-input py-3 px-5 form-control-lg custom-placeholder theme-text-color mb-3"
                  id="newsletter_template"
                  name="newsletter_template"
                  ref={newsletterTemplateRef}
                  value={editUser?.newsletter_template}
                  onChange={handleInput}
                  placeholder="Enter newsletter template content..."
                  rows="6"
                  style={{ resize: 'vertical', minHeight: '120px' }}
                />
                {editUserError?.newsletter_template && (<MessageBox text={`${editUserError?.newsletter_template}`} classname='errorred mb-2 d-block' />)}
              </>
            )}
          </Wrapper>
          <Wrapper>
            <MessageHeading text='Test Mail' />
            <MessageLabel text="Send email to User" className="" />
            <AdminCustomInput type="email" id="test_mail" placeHolder={"Enter test user email"} name="test_mail" ref={userTestEmailRef} value={editUser?.test_mail} onChange={handleInput} error={editUserError?.test_mail} />
            <AdminCustomButton saveMethod={handleTestEmailValid} saveText="Send" className={"d-flex justify-content-end ms-auto"} />
          </Wrapper>
        </RightWrapper>

      </FormContainer>

      <div className="d-flex justify-content-end mt-4 mb-4">
        <AdminCustomButton saveMethod={handleValidate} saveText="Update Settings" />
      </div>



      {/* {productType == 'full_package' && */}
      <>
        <FormContainer className="gap-3">
          <AdminCustomButton className={`${activeTableView !== 'email' && 'btn-secondary'}`} saveText="Email" saveMethod={() => setActiveTableView('email')} />
          <AdminCustomButton className={`${activeTableView !== 'newsletter' && 'btn-secondary'}`} saveText="News Letter" saveMethod={() => setActiveTableView('newsletter')} />
        </FormContainer>
        <div className="mt-4">
          {/* Toggle Buttons */}


          {/* Email Templates Table */}
          {activeTableView === 'email' && (
            <div className="bootstrapTable p-3 rounded-2 theme-bg-color">
              <AdminNavbar
                heading={'Email Templates'}
                searchMethod={handleFilterChange}
                totalDataLength={template.length}
                deleteCount={0}
                navigation={'/email-logs'}
                deleteMethod={null}
                navText={'Email Logs'}
                addIconHide
              />
              <div className="filterContainer">
                <input
                  type="text"
                  placeholder="Search"
                  className="filter form-control theme-text-color theme-border-secondary theme-bg-color-secondary"
                  onChange={(e) => handleFilterChange(e.target.value)}
                />
              </div>
              <BootstrapTable
                keyField="id"
                pagination={paginationFactory(options)}
                columns={columns}
                data={template}
                className="no-border-table theme-text-color"
                noDataIndication={<NoRecordTable result={template?.length} loader={false} />}
                hover
                headerClasses="videoWidth"
              />
            </div>
          )}

          {/* Newsletter Templates Table */}
          {/* {activeTableView === 'newsletter' && (
              <div className="bootstrapTable p-3 rounded-2 theme-bg-color">
                <AdminNavbar
                  heading={'Newsletter Templates'}
                  searchMethod={null}
                  totalDataLength={newsletterTemplates.length}
                  deleteCount={0}
                  navigation={'/newsletter-logs'}
                  deleteMethod={null}
                  navText={'Newsletter Logs'}
                  addText={'Add Newsletter Template'}
                  addNavigation={'/add-newsletter-template'}
                />
                <BootstrapTable
                  keyField="id"
                  pagination={paginationFactory({
                    totalSize: newsletterTemplates.length,
                    page: currentPage,
                    onPageChange: (page) => setCurrentPage(page),
                    onSizePerPageChange: (sizePerPage, page) => {
                      setPageSize(sizePerPage);
                      setCurrentPage(page);
                    },
                    pageStartIndex: 1,
                    paginationSize: 3,
                    sizePerPage: pageSize,
                    nextPageText: "Next",
                    prePageText: "Prev",
                    firstPageText: <MdKeyboardDoubleArrowLeft />,
                    lastPageText: <MdKeyboardDoubleArrowRight />,
                    showTotal: true,
                    alwaysShowAllBtns: true,
                    sizePerPageList: [
                      { text: '5', value: 5 },
                      { text: '10', value: 10 },
                      { text: 'All', value: newsletterTemplates?.length || 0 }
                    ]
                  })}
                  columns={newsletterColumns}
                  data={newsletterTemplates}
                  className="no-border-table theme-text-color"
                  noDataIndication={<NoRecordTable result={newsletterTemplates?.length} loader={false} />}
                  hover
                  headerClasses="videoWidth"
                />
              </div>
            )} */}
        </div>
      </>
      {/* } */}
    </div>
  );
}

export default EmailSettings;
